export default __webpack_public_path__ + "static/pedals-cd8703617de7b839a1522c8920763d35.svg";